<div class="container">
    <app-login-template>
    <div class="login">
        <div class="title"><img style="width: 150px;" src="assets/img/everight-logo-small.png" alt="logo" /></div>
        <div class="form">
            <div class="input">
                <mat-form-field class="example-full-width">
                    <mat-label>User Name</mat-label>
                    <input type="text" matInput placeholder="">
                  </mat-form-field>
            </div>
            <div class="input">
                <mat-form-field class="example-full-width">
                    <mat-label>Password</mat-label>
                    <input type="password" matInput placeholder="***********">
                  </mat-form-field>
            </div>
        </div>
        <div class="button">
            <button class="button" mat-raised-button color="primary">Sign Up</button>
        </div>
    </div>
    </app-login-template>
</div>